import { formatSwedishDateTime } from '@/lib/format'
import type { ThemeConfig } from 'antd'
import type { DropdownsConfig, Locale, PeriodType } from 'react-js-cron'
import type { JobSchedule } from '@/api/types'

const PRIMARY_COLOR = '#527c72'
const INACTIVE_LABEL = 'Körs inte automatiskt'
const NO_UPCOMING_RUN_LABEL = 'Ingen kommande körning'
const NEXT_RUN_PREFIX = 'Nästa körning'

export const SCHEDULE_PERIODS: PeriodType[] = ['year', 'month', 'week', 'day', 'hour']

export const SCHEDULE_DROPDOWNS: DropdownsConfig = {
  minutes: { mode: 'single' }
}

export const SCHEDULE_EDITOR_THEME: ThemeConfig = {
  token: {
    colorPrimary: PRIMARY_COLOR,
    borderRadius: 0,
    fontFamily: 'inherit'
  }
}

export const SWEDISH_CRON_LOCALE: Locale = {
  everyText: 'var',
  emptyMonths: 'varje månad',
  emptyMonthDays: 'varje dag i månaden',
  emptyMonthDaysShort: 'dag i månaden',
  emptyWeekDays: 'varje veckodag',
  emptyWeekDaysShort: 'veckodag',
  emptyHours: 'varje timme',
  emptyMinutes: 'varje minut',
  emptyMinutesForHourPeriod: 'varje',
  yearOption: 'år',
  monthOption: 'månad',
  weekOption: 'vecka',
  dayOption: 'dag',
  hourOption: 'timme',
  minuteOption: 'minut',
  rebootOption: 'omstart',
  prefixPeriod: 'Varje',
  prefixMonths: 'i',
  prefixMonthDays: 'den',
  prefixWeekDays: 'på',
  prefixWeekDaysForMonthAndYearPeriod: 'och',
  prefixHours: 'kl.',
  prefixMinutes: ':',
  prefixMinutesForHourPeriod: '',
  suffixMinutesForHourPeriod: 'minuter över',
  errorInvalidCron: 'Välj när jobbet ska köras',
  clearButtonText: 'Rensa',
  weekDays: ['söndag', 'måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag'],
  months: ['januari', 'februari', 'mars', 'april', 'maj', 'juni', 'juli', 'augusti', 'september', 'oktober', 'november', 'december'],
  altWeekDays: ['SÖN', 'MÅN', 'TIS', 'ONS', 'TOR', 'FRE', 'LÖR'],
  altMonths: ['JAN', 'FEB', 'MAR', 'APR', 'MAJ', 'JUN', 'JUL', 'AUG', 'SEP', 'OKT', 'NOV', 'DEC']
}

export function formatNextRun(schedule: JobSchedule): string {
  if (!schedule.active) {
    return INACTIVE_LABEL
  }

  if (schedule.next_run_at === null) {
    return NO_UPCOMING_RUN_LABEL
  }

  return `${NEXT_RUN_PREFIX} ${formatSwedishDateTime(schedule.next_run_at)}`
}
